import type { Subscription } from '../types/subscription';
import SubscriptionTerm from '../constants/subscription-term';
import isPaidHostingPackageType from './is-paid-hosting-package-type';

function hasAnnualPaidHostingSubscription(subscriptions: Subscription[]): boolean {
  return subscriptions.some(
    (subscription: Subscription) =>
      isPaidHostingPackageType(subscription.type) && subscription.term === SubscriptionTerm.ANNUAL
  );
}

export default hasAnnualPaidHostingSubscription;
